import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NegotiationsService } from 'src/app/services/negotiations.service';
import { fetchNegotiations, newNegotiationData } from './negotiations.actions';
import { map, mergeMap } from 'rxjs';

@Injectable()
export class NegotiationsEffects {
  private negotiationsService = inject(NegotiationsService);
  private actions$ = inject(Actions);

  loadNegotiationsData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchNegotiations),
      mergeMap((action) => {
        return this.negotiationsService
          .watch({ fetchPolicy: 'cache-and-network' })
          .valueChanges.pipe(
            map((res) => {
              return newNegotiationData({
                negotiations: res.data.negotiations,
              });
            })
          );
      })
    );
  });
}
